import React, { FC, ReactNode } from 'react';
import { Button } from 'flowbite-react';
import ProtectWithLogin from '../ProtectWithLogin/ProtectWithLogin';

type TQuoteHighlightingToolbarButtonProps = {
  children: ReactNode;
  leftAdornment?: ReactNode;
  onClick?: () => void;
};

export const QuoteHighlightingToolbarButton: FC<TQuoteHighlightingToolbarButtonProps> = ({
  children,
  leftAdornment,
  onClick,
}) => (
  <ProtectWithLogin>
    <Button
      size="sm"
      className="w-full !rounded-[4px] p-2 text-t2-shades-white !text-sm whitespace-nowrap bg-t2-neutral-grey07 hover:!bg-t2-neutral-grey06 focus:!ring-0"
      onClick={onClick}
    >
      <div className="flex gap-2">
        {leftAdornment && <div>{leftAdornment}</div>}
        {children}
      </div>
    </Button>
  </ProtectWithLogin>
);
